// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimsList-cls1_83F","cls2":"ClaimsList-cls2_i6T ClaimsList-cls1_83F"};